import React from 'react';

import useDialogAccessibilityFeatures from 'shared-utils/src/useDialogAccessibilityFeatures'; 

import PTypes from '../ContentPTypesQB';

const LicenseTypeGroups = (props) => {
  const {
    queryBuilderProps: {
      isActivePanel,
      panelId,
      headerTitleId,
      closeModal,
    } = {},
  } = props;

  useDialogAccessibilityFeatures(isActivePanel ? {
    elementId: panelId,
    isOpen: isActivePanel,
    closefn: () => closeModal(),
    customFocusableElements: [`#${headerTitleId}`],
  } : {});

  return (
    <PTypes {...props} content="license_type_groups" />
  );
};

export default LicenseTypeGroups;
